/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createString } from '../../factoriesAny.js';
export var stringDependencies = {
  typedDependencies,
  createString
};